<template>
  <div class="google-map-print">
    <google-map input-box="1"></google-map>
  </div>
</template>

<script>
import GoogleMap from './GoogleMap'
export default {
  name: 'google-map-print',
  components: { GoogleMap }
}
</script>

<style lang="scss" scoped>
.google-map-print {
  .google-map {
    width: 100%;
    height: 100%;
  }
}
</style>
